// Mirrors billing-pdf-generator's `src/util/address.ts` so the hosted invoice
// page renders the same address line as the PDF (source of truth).
const getStatePostCode = (state?: string | null, postcode?: string | null) => {
  if (state && postcode) return `${state} ${postcode}`;
  if (!state && !postcode) return '';
  return state || postcode || '';
};

export const getAddressLine2 = (city?: string | null, state?: string | null, postcode?: string | null) => {
  if (city) {
    const statePostCode = getStatePostCode(state, postcode);
    return statePostCode ? `${city}, ${statePostCode}` : city;
  }
  return getStatePostCode(state, postcode);
};
